(function ($) {
  $(document).ready(function () {
    var header = $('.header');

    // Add scroll event listener
    $(window).on('load scroll', function () {
      // Check the scroll position
      var scrollPosition = $(window).scrollTop();

      // Add or remove class based on the scroll position
      if (scrollPosition > 0) {
        header.addClass('fixed-header');
      } else {
        header.removeClass('fixed-header');
      }
    });
    var mobile_toggle = $('.mobile-menu .toggle');
    mobile_toggle.on('click', function () {
      $('body').toggleClass('menu-active');
    });

    // Detect mobile device and add class for card flip

    var $areas = $('.areas');
    var $flipBtn = $('.flip-btn');
    function isTouchDevice() {
      return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 || window.matchMedia("(pointer: coarse)").matches;
    }
    if ($areas.length) {
      if (isTouchDevice()) {
        $areas.removeClass('desktop').addClass('mobile');
      } else {
        $areas.removeClass('mobile').addClass('desktop');
      }
    }
    $flipBtn.on('click', function () {
      $(this).parents('.area-card').toggleClass('back');
    });
  });

  // Prevent copy, cut, paste, and view source via keyboard shortcuts
  $(document).on('keydown', function (e) {
    if ((e.ctrlKey || e.metaKey) && (e.key === 'c' || e.key === 'x' || e.key === 'v' || e.key === 'u')) {
      e.preventDefault();
    }
  });

  // Prevent right-click context menu
  $(document).on('contextmenu', function (e) {
    e.preventDefault();
  });

  // Prevent text selection
  $(document).on('selectstart', function (e) {
    if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'TEXTAREA') {
      e.preventDefault();
    }
  });

  // Prevent content copy on mobile by disabling long press and text selection
  $('body').on('touchstart', function (e) {
    if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'TEXTAREA') {
      e.preventDefault();
    }
  });

  // Disable long press context menu on mobile devices
  $('body').css({
    'user-select': 'none',
    // Disable text selection
    '-webkit-user-select': 'none',
    // Disable text selection for Safari
    '-moz-user-select': 'none',
    // Disable text selection for Firefox
    '-ms-user-select': 'none',
    // Disable text selection for IE/Edge
    '-webkit-touch-callout': 'none',
    // Disable callout on long press for iOS
    'touch-action': 'manipulation' // Prevent default actions on touch devices
  });
})(jQuery);